import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';

import { createBadgeAsync, getBadgesLookupsAsync } from './slices';
import { CreateBadgeInput } from './types';

export const getBadgesLookups = async (
  searchString?: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getBadgesLookupsAsync(searchString));

  return handleDispatchResult(res, onSuccess);
};

export const createBadge = async (
  body: CreateBadgeInput,
  onSuccess?: (id: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createBadgeAsync(body));

  return handleDispatchResult(res, onSuccess);
};
